import { TCommonData } from './data';
import { TWAction } from './widget';

type TCardInputDataMessages = {
    cardNumberTitle?: string;
    cardExpDateTitle?: string;
    cardDescription?: string;
};

export enum EFieldType {
    CARD_NUMBER = 'CARD_NUMBER',
    EXP_DATE = 'EXP_DATE',
    CARD = 'CARD',
}

export type TCardInputError = {
    field: EFieldType;
    shortText: string;
    actions?: TWAction[];
};

export type TCardInputData = {
    bankTitle?: string;
    bankImage?: string;
    paymentSystemIcon?: string;
    submitNumberTextLength?: number;
    isValid?: boolean;
    tabIndex?: number;
    messages?: TCardInputDataMessages;
    errors?: TCardInputError[];
    mode?: 'simple' | 'full';
} & TCommonData;
